import type { BenefitsUsagePageDataCollectionQuery } from 'generated/resources/graphql'

import type { EmployeeSpendingData } from './types'

export function extractEmployeeData(
  data: BenefitsUsagePageDataCollectionQuery
): EmployeeSpendingData[] {
  return (
    data.benefits?.benefitEmployeesConnection?.nodes
      ?.map((node) => node?.employeeName)
      .filter((employeeName): employeeName is NonNullable<typeof employeeName> =>
        Boolean(employeeName)
      )
      .map((employeeName) => {
        const consolidatedAmounts = (employeeName.benefitCompensations ?? []).reduce(
          (acc, compensation) => {
            return {
              ...acc,
              [compensation.category]: compensation.amountCents,
            }
          },
          {
            meals: 0,
            transportation: 0,
            childcare: 0,
            unsupported: 0,
            training: 0,
            healthcare: 0,
            wellness: 0,
          }
        )

        return {
          ...employeeName,
          amounts: consolidatedAmounts,
        }
      }) ?? []
  )
}
